$(document).ready(function(){
    if($('.inkube-summary-list').length){
        $(document).on('click','.inkube-summary-list li[data-target]',function(e){
            e.preventDefault();
            let target = atob($(this).data('target')).substr(1);
            console.log(target);
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000);
        })
    }
});